import { ChainId } from './chain-icon';

export const CHAINS: Record<ChainId, { label: string }> = {
  sui: { label: 'Sui' },
  ethereum: { label: 'Ethereum' },
  base: { label: 'Base' },
  arbitrum: { label: 'Arbitrum' },
  optimism: { label: 'Optimism' },
  avalanche: { label: 'Avalanche' },
  solana: { label: 'Solana' },
};

export const RECEIVE_NETWORKS = ['sui', 'ethereum', 'base', 'solana'] as const satisfies ChainId[];
